module.exports = __webpack_public_path__ + "static/ancient-dragons-hoard-3e9a905bde9bb0f73f1870e294196ec1.png";